module.exports = __webpack_public_path__ + "media/site/images/contact-slider/contact_slideshow-10-2807ae9ae902cf2595028c5412a220f0.jpg";